/**
 * Frontend mirror of auth.py::can_see_dwa_dashboard().
 *
 * MUST stay in sync with the backend rules — see app/services/agent/app/auth.py
 * for the canonical implementation. The frontend uses this for UX gating
 * (hide menu items, show "Not authorized" page) but the backend's
 * assert_can_see_dwa_dashboard() is the security gate.
 *
 * Rules:
 *   role=dwa_admin  → unconditional access
 *   role=dwa_standard:
 *     - If client_access[dwa-internal] has no `dashboards` field → all access
 *       (legacy default-allow until admin scopes them via the UI)
 *     - If `dashboards` is present → explicit allowlist (default-deny within)
 *   role=client     → never sees DWA dashboards
 */
import type { User } from '../types';

export function canSeeDwaDashboard(user: User | null | undefined, dashboardSlug: string): boolean {
  if (!user) return false;
  if (user.role === 'dwa_admin') return true;
  if (user.role === 'client') return false;

  // dwa_standard
  const access = user.client_access || [];
  const entry = access.find((e) => e.client_id === 'dwa-internal');
  if (!entry) return true;             // no entry → legacy default-allow
  if (!entry.dashboards) return true;   // no `dashboards` field → legacy default-allow
  return entry.dashboards.includes(dashboardSlug);
}
